import { Button, Input, VerticalContainer } from '@/components';
import React, { useState } from 'react';
import { FormControl } from '@/caregiverSpace/shared/ui';

type BmiCalculatorProps = {
    setPageIndex: (arg: number) => void;
    setBmi: (arg: number) => void;
    height: number;
    setHeight: (arg: number) => void;
    weight: number;
    setWeight: (arg: number) => void;
};

export function BmiCalculator({
    setPageIndex,
    setBmi,
    height,
    setHeight,
    weight,
    setWeight,
}: BmiCalculatorProps) {
    const [showHeightError, setShowHeightError] = useState(false);
    const [showWeightError, setShowWeightError] = useState(false);
    const [heightInput, setHeightInput] = useState<string>(
        height ? height.toString() : '',
    );
    const [weightInput, setWeightInput] = useState<string>(
        weight ? weight.toString() : '',
    );

    function calculateBmiAndGoForward() {
        const h = Number(heightInput.replace(',', '.'));
        const w = Number(weightInput.replace(',', '.'));

        let hasHeightError = false;
        let hasWeightError = false;

        if (h < 50 || h > 272) {
            hasHeightError = true;
        }

        if (w < 1 || w > 635) {
            hasWeightError = true;
        }

        setShowHeightError(hasHeightError);
        setShowWeightError(hasWeightError);

        if (hasWeightError || hasHeightError) return;

        const bmi = w / (h / 100) / (h / 100);

        setHeight(h);
        setWeight(w);
        setBmi(bmi);
        setPageIndex(1);
    }

    function validateAndSetValue(
        e: React.ChangeEvent<HTMLInputElement>,
        setValue: (arg: string) => void,
    ) {
        const regex = /^\d+[,.]?\d*$/;
        if (e.target.value === '' || regex.test(e.target.value)) {
            setValue(e.target.value);
            setShowHeightError(false);
        }
    }

    const weightErrorMsg = 'Indtast venligst din vægt i kg og prøv igen.';
    const heightErrorMsg = 'Indtast venligst din højde i cm og prøv igen.';

    return (
        <>
            <div className="text-xl font-bold text-(--color-text-heading)">
                Udregn dit BMI
            </div>

            <div className="my-4 py-1 text-lg leading-normal">
                SundVægt programmet hos Hejdoktor tilbydes kun til personer, der
                lider af moderat eller svær overvægt. Programmet er for dig, der
                har et BMI over 30, eller et BMI over 27 og mindst én
                vægtrelateret sygdom. Her kan du udregne dit BMI og samtidig
                tilmelde dig SundVægt forløbet.
            </div>

            <VerticalContainer
                spacing="lg"
                className="rounded-lg bg-(--color-bg-subtle) p-4 sm:px-8 sm:py-6"
            >
                <FormControl
                    label="Højde i cm"
                    error={showHeightError ? heightErrorMsg : ''}
                >
                    <Input
                        name="height-input"
                        value={heightInput}
                        onChange={(e) => validateAndSetValue(e, setHeightInput)}
                        className="mt-2"
                        inputMode="decimal"
                        placeholder="f.eks. 170"
                    />
                </FormControl>

                <FormControl
                    label="Vægt i kg"
                    error={showWeightError ? weightErrorMsg : ''}
                >
                    <Input
                        name="weight-input"
                        value={weightInput}
                        onChange={(e) => validateAndSetValue(e, setWeightInput)}
                        className="mt-2"
                        inputMode="decimal"
                        placeholder="f.eks. 100"
                    />
                </FormControl>

                <Button
                    variant="primary"
                    onClick={calculateBmiAndGoForward}
                    className="w-full"
                >
                    Udregn BMI
                </Button>
            </VerticalContainer>
        </>
    );
}
